module.exports = __webpack_public_path__ + "img/9788994210384.de98f7fd.jpg";